var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcShareWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2546 9.37373C20.7094 9.39199 20.5328 9.8362 20.5328 10.4647V20.0646H1.4V10.4647C1.4 9.8362 1.31937 9.37373 0.690912 9.37373C0.145457 9.37372 0 9.8362 0 10.4647L0.0909119 20.0646C0.0909119 21.1121 0.352566 21.4647 1.4 21.4647H20.5328C21.5803 21.4647 22 21.1121 22 20.0646V10.4647C22 9.8362 21.8909 9.35241 21.2546 9.37373Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4853 0.73681C11.219 0.470543 10.7873 0.470543 10.5211 0.73681L6.43017 4.82772C6.1639 5.09399 6.1639 5.52569 6.43017 5.79196C6.69644 6.05823 7.12814 6.05823 7.39441 5.79196L10.3678 2.81512V16.3448C10.3678 16.7121 10.6655 17.0098 11.0328 17.0098C11.4 17.0098 11.6978 16.7121 11.6978 16.3448V2.86548L14.612 5.79196C14.8783 6.05823 15.31 6.05823 15.5762 5.79196C15.8425 5.52569 15.8425 5.09399 15.5762 4.82772L11.4853 0.73681Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShareWhite);
export default __webpack_public_path__ + "static/media/icShareWhite.95fc8c20f64674c8aa82b41d6a665f5e.svg";
export { ForwardRef as ReactComponent };